// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".owner-email-block .el-input__inner{height:51px !important;border-radius:8px}.owner-email-block .el-input__inner.invalid{border-color:#e71717 !important}.owner-email-block .el-form-item__error{text-align:left !important;color:#e71717 !important;font-family:Inter !important;font-size:12px !important;font-weight:400 !important;line-height:15px !important;letter-spacing:0em !important;text-align:left !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
